import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { supabase } from '../lib/supabaseClient';

/**
 * Both numbers come from security-definer RPCs (not direct table reads) so
 * anon visitors can see an aggregate count without profiles/purchases RLS
 * having to open up row-level access. Fetched fresh on every load — this is
 * "live" in the sense of always-accurate, not a push/realtime subscription.
 */
export default function LiveStats() {
  const [users, setUsers] = useState(null);
  const [sessions, setSessions] = useState(null);

  useEffect(() => {
    let cancelled = false;
    supabase.rpc('get_registered_users_count').then(({ data }) => {
      if (!cancelled) setUsers(data ?? 0);
    });
    supabase.rpc('get_completed_sessions_count').then(({ data }) => {
      if (!cancelled) setSessions(data ?? 0);
    });
    return () => { cancelled = true; };
  }, []);

  const items = [
    { value: users, label: 'students registered' },
    { value: sessions, label: 'mentorship sessions completed' },
  ];

  return (
    <section className="border-t border-line/70 px-4 py-10 sm:px-5">
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-40px' }}
        transition={{ duration: 0.5 }}
        className="mx-auto flex max-w-page flex-wrap items-center justify-center gap-x-16 gap-y-6 text-center"
      >
        {items.map((it) => (
          <div key={it.label}>
            <p className="font-display text-3xl font-bold text-white md:text-4xl">
              {it.value === null ? '—' : it.value.toLocaleString('en-IN')}
            </p>
            <p className="mt-1 text-sm text-white/45">{it.label}</p>
          </div>
        ))}
      </motion.div>
    </section>
  );
}
